<div class="mwp-modal d-inline-flex">
  <div>
    <div class="modal-header no-border w-100 d-flex justify-content-center align-items-center">
      <div class="title d-inline-flex w-100">
        <mwp-text-translate text="EDIT BENEFICIARIES" jsonKey="editBeneficiaries" />
      </div>
    </div>
    @if (isEdit && benefitBeneficiaryCard) {
      <div class="px-3">
          <mwp-beneficiaries-form [benefitBeneficiaryCard]="benefitBeneficiaryCard" (emitCancel)="closeDialog()" (emitSaveCardModal)="saveUpdatedBeneficiaries($event)" [isModal]="true" saveButtonText="Next" />
      </div>
    }
    @if (isSelectBenefits) {
      <div>
        <mwp-beneficiaries-benefit-select [benefitBeneficiaryCard]="benefitBeneficiaryCard" [beneficiariesList]="beneficiariesList" saveButtonText="Save" (emitCancel)="closeDialog()" (emitSavePayload)="saveAndCloseDialog($event)" />
      </div>
    }
  </div>
</div>